import { BinaryFrame } from '../transport/protocol';
import { CapabilityReport } from '../probe/capabilities';
import { WasmH264Renderer } from './wasm';
import { WebCodecsRenderer } from './webcodecs';
import { UnsupportedVideoRenderer } from './unsupported';

export interface VideoRenderer {
  initialize(canvas: HTMLCanvasElement): Promise<void>;
  renderFrame(frame: BinaryFrame): void;
  reset(): void;
  destroy(): void;
  getFps(): number;
  getName(): string;
}

export { SyntheticCanvasRenderer } from './synthetic';
export { WebCodecsRenderer } from './webcodecs';

/**
 * Factory function to create and initialize the optimal renderer based on capability report
 */
export async function createRenderer(
  canvas: HTMLCanvasElement,
  report: CapabilityReport,
  onKeyframeNeeded: () => void = () => {}
): Promise<VideoRenderer> {
  let renderer: VideoRenderer;

  if (report.selectedRenderer === 'webcodecs') {
    renderer = new WebCodecsRenderer(onKeyframeNeeded, report.features.webAssembly);
  } else if (report.selectedRenderer === 'wasm-h264' && report.features.webAssembly) {
    renderer = new WasmH264Renderer();
  } else {
    renderer = new UnsupportedVideoRenderer();
  }

  try {
    await renderer.initialize(canvas);
  } catch (error) {
    console.warn('[DriveDeck] Renderer initialization failed:', error);
    renderer.destroy();
    renderer = new UnsupportedVideoRenderer();
    await renderer.initialize(canvas);
  }
  return renderer;
}
